import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTable, useExpanded } from "react-table";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";

const RentedItemRequirementReport = () => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= FETCH PROJECT LIST ================= */

  useEffect(() => {
    apiClient.get(`${SERVER_BASE}/area-projects`).then((res) => {
      setProjects([
        { value: "Regular", label: "Regular" },
        ...res.data.map((p) => ({
          value: p.id,
          label: p.projectName,
        })),
      ]);
    });
  }, []);

  /* ================= FETCH REPORT DATA ================= */

  const fetchReport = async () => {
    if (!selectedProject || selectedProject.value === "Regular") {
      alert("Please select a project");
      return;
    }

    try {
      setLoading(true);

      const res = await apiClient.get(
        `${SERVER_BASE}/getRentedItemRequirementReport/${selectedProject.value}`
      );

      setData(res.data || []);
    } catch (error) {
      console.error("Error fetching report:", error);
      alert("Failed to fetch report");
    } finally {
      setLoading(false);
    }
  };

  /* ================= TABLE COLUMNS ================= */

  const columns = useMemo(
    () => [
      {
        Header: "Item",
        accessor: "printName",
      },
      {
        Header: "Qty",
        accessor: "totalRequiredQuantity",
      },
      {
        Header: "UOM",
        accessor: "uom",
      },
    ],
    []
  );

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useExpanded
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = tableInstance;

  /* ================= SUB TABLE (DEPARTMENT WISE) ================= */

  const renderSubRow = (row) => {
    const deptData = row.original.departmentRequirements || [];

    return (
      <div className="p-3 bg-light">
        <strong>Department Wise Requirement</strong>

        <table className="table table-striped mt-2 mb-0">
          <thead className="table-secondary">
            <tr>
              <th>Department</th>
              <th>Quantity</th>
              <th>Remarks</th>
              {/* <th>Source</th> */}
            </tr>
          </thead>
          <tbody>
            {deptData.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center">
                  No Data
                </td>
              </tr>
            ) : (
              deptData.map((d, idx) => (
                <tr key={idx}>
                  <td>{d.department}</td>
                  <td>{d.quantity}</td>
                  <td>{d.remarks}</td>
                  {/* <td>{d.source}</td> */}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  };

  /* ================= UI ================= */

  return (
    <div className="formcontainer mt-3">
      <div className="">
          <h5 className="mb-0">Rented Item Requirement Report</h5>
          {/* ================= FILTER ROW ================= */}
          <div className="row mb-3">
            <div className="col-md-4">
              <label className="form-label">Project</label>
              <Select
                options={projects}
                value={selectedProject}
                onChange={setSelectedProject}
                placeholder="Select Project"
              />
            </div>

            <div className="col-md-2 d-flex align-items-end">
              <button className="btn btn-success" onClick={fetchReport}>
                Get
              </button>
            </div>
          </div>

          {/* ================= TABLE ================= */}

          {loading ? (
            <div className="text-center mt-4">
              <div className="spinner-border" role="status" />
            </div>
          ) : (
            <table
              className="table table-striped table-bordered"
              {...getTableProps()}
            >
              <thead className="table-secondary">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    <th style={{ width: "40px" }}></th>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>

              <tbody {...getTableBodyProps()}>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No data found
                    </td>
                  </tr>
                ) : (
                  rows.map((row) => {
                    prepareRow(row);

                    return (
                      <React.Fragment key={row.id}>
                        <tr {...row.getRowProps()}>
                          {/* Expand Button */}
                          <td className="text-center">
                            <span
                              {...row.getToggleRowExpandedProps()}
                              style={{
                                cursor: "pointer",
                                fontWeight: "bold",
                              }}
                            >
                              {row.isExpanded ? "-" : "+"}
                            </span>
                          </td>

                          {row.cells.map((cell) => (
                            <td {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>

                        {/* Expanded Content */}
                        {row.isExpanded && (
                          <tr>
                            <td colSpan="4">{renderSubRow(row)}</td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })
                )}
              </tbody>
            </table>
          )}

      </div>
    </div>
  );
};

export default RentedItemRequirementReport;
